import { IIcon } from '@/types/generalTypes';

const FlagIcon = ({ className }: IIcon) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.6665 10C2.6665 10 3.33317 9.33337 5.33317 9.33337C7.33317 9.33337 8.6665 10.6667 10.6665 10.6667C12.6665 10.6667 13.3332 10 13.3332 10V2.00004C13.3332 2.00004 12.6665 2.66671 10.6665 2.66671C8.6665 2.66671 7.33317 1.33337 5.33317 1.33337C3.33317 1.33337 2.6665 2.00004 2.6665 2.00004V10ZM2.6665 10V14.6667'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default FlagIcon;
